import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivateViewsComponent } from './private-views.component'
export const routes: Routes = [
  {
    path: 'home', component: PrivateViewsComponent,
    data: {
      title: 'Home'
    },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        data: {
          title: 'Dashboard'
        }
      },
      {
        path: 'graphical-representation',
        loadChildren: './graphical-representation/graphical-representation.module#GraphicalRepresentationModule',
        data: {
          title: 'Analytics'
        }
      },
      {
        path: 'user-list',
        loadChildren: './user-module/user-list/user-list.module#UserListModule',
        data: {
          title: 'User List'
        }
      },
      {
        path: 'reported-by-users',
        loadChildren: './user-module/reported-by-users/reported-by-users.module#ReportedByUsersModule',
        data: {
          title: 'Reported by Users'
        }
      },
      {
        path: 'inactive-users',
        loadChildren: './user-module/inactive-users/inactive-users.module#InactiveUsersModule',
        data: {
          title: 'Inactive Users'
        }
      },
      {
        path: 'suspended-users',
        loadChildren: './user-module/suspended-users/suspended-users.module#SuspendedUsersModule',
        data: {
          title: 'Suspended Users'
        }
      },
      {
        path: 'deactivated-users',
        loadChildren: './user-module/deactivated-users/deactivated-users.module#DeactivatedUsersModule',
        data: {
          title: 'Deactivated Users'
        }
      },
      {
        path: 'edit-user/:id',
        loadChildren: './user-module/edit-user/edit-user.module#EditUserModule',
        data: {
          title: 'Edit User'
        }
      },
      {
        path: 'reset-password/:id',
        loadChildren: './user-module/reset-password/reset-password.module#ResetPasswordModule',
        data: {
          title: 'Reset Password'
        }
      },
      {
        path: 'preview-user/:id',
        loadChildren: './user-module/preview-user/preview-user.module#PreviewUserModule',
        data: {
          title: 'Preview User'
        }
      },
      {
        path: 'reported-users',
        loadChildren: './user-module/reported-users/reported-users.module#ReportedUsersModule',
        data: {
          title: 'Reported Users'
        }
      },
      {
        path: 'preview-reported-users/:id',
        loadChildren: './user-module/preview-reported-user/preview-reported-user.module#PreviewReportedUserModule',
        data: {
          title: 'Reported Users'
        }
      },
      {
        path: 'groups-list',
        loadChildren: './groups-module/groups-list/groups-list.module#GroupsListModule',
        data: {
          title: 'Groups List'
        }
      },
      {
        path: 'reported-groups',
        loadChildren: './groups-module/reported-groups/reported-groups.module#ReportedGroupsModule',
        data: {
          title: 'Reported Groups'
        }
      },
      {
        path: 'edit-group/:id/:groupName',
        loadChildren: './groups-module/edit-group/edit-group.module#EditGroupModule',
        data: {
          title: 'Members List'
        }
      },
      {
        path: 'preview-group/:id',
        loadChildren: './groups-module/preview-group/preview-group.module#PreviewGroupModule',
        data: {
          title: 'Preview Group'
        }
      },
      {
        path: 'change-password',
        loadChildren: './change-password/change-password.module#ChangePasswordModule',
        data: {
          title: 'Change Password'
        }
      },
      {
        path: 'interests',
        loadChildren: './interests/interests.module#InterestsModule',
        data: {
          title: 'Interests'
        }
      },
      {
        path: 'campaign-labels',
        loadChildren: './campaign-labels/campaign-labels.module#CampaignLabelsModule',
        data: {
          title: 'Campaign Labels'
        }
      },
      {
        path: 'occupations',
        loadChildren: './occupations/occupations.module#OccupationsModule',
        data: {
          title: 'Occupations'
        }
      },
      {
        path: 'push-notifications',
        loadChildren: './push-notifications/push-notifications.module#PushNotificationsModule',
        data: {
          title: 'Push Notifications'
        }
      },
      {
        path: 'contacted-users',
        loadChildren: './signup-list/signup-list.module#SignupListModule',
        data: {
          title: 'Contacted Users'
        }
      },
      {
        path: 'mail-marketing',
        loadChildren: './mail-marketing/mail-marketing.module#MailMarketingModule',
        data: {
          title: 'Mail Marketing'
        }
      },      
      {
        path: 'privacy-policy',
        loadChildren: './privacy-policy/privacy-policy.module#PrivacyPolicyModule',
        data: {
          title: 'Privacy Policy'
        }
      },
      {
        path: 'terms-of-service',
        loadChildren: './terms-of-service/terms-of-service.module#TermsOfServiceModule',
        data: {
          title: 'Terms of service'
        }
      },
      {
        path: 'suspended-usertime',
        loadChildren: './suspended-usertime/suspended-usertime.module#SuspendedUsertimeModule',
        data: {
          title: 'Suspended User Time'
        }
      },
      {
        path: 'version-update',
        loadChildren: './version-update/version-update.module#VersionUpdateModule',
        data: {
          title: 'Version Update'
        }
      },
      {
        path: 'referral-list',
        loadChildren: './user-referral-module/user-list/user-list.module#UserListModule',
        data: {
          title: 'Referral List'
        }
      },
      {
        path: 'referred-user-list/:id',
        loadChildren: './user-referral-module/referred-user-list/referred-user-list.module#RefferedUserListModule',
        data: {
          title: 'Referred User List'
        }
      },
      {
        path: 'user-refferal-rules/:id',
        loadChildren: './user-referral-module/user-referral-rules/user-referral-rules.module#UserRefferalRulesModule',
        data: {
          title: 'User Achived Rewards'
        }
      },
      {
        path: 'refferal-rules',
        loadChildren: './referral-rule-module/referral-rule-list/referral-rule-list.module#ReferralRuleListModule',
        data: {
          title: 'Referral Rules'
        }
      },
      {
        path: 'broadcast',
        loadChildren: './broadcast/broadcast.module#BroadcastModule',
        data: {
          title: 'Broadcast'
        }
      },
      {
        path: 'broadcast-messages/:label',
        loadChildren: './broadcast-messages/broadcast-messages.module#BroadcastMessagesModule',
        data: {
          title: 'Broadcast Messages'
        }
      },
      {
        path: 'broadcast-messages',
        loadChildren: './broadcast-messages/broadcast-messages.module#BroadcastMessagesModule',
        data: {
          title: 'Broadcast Messages'
        }
      },
      {
        path: 'coupon-code-list/:id',
        loadChildren: './referral-rule-module/referral-rule-coupon-code-list/referral-rule-coupon-code-list.module#ReferralRuleCouponCodeListModule',
        data: {
          title: 'Coupon Code List'
        }
      },
      { path: '**', redirectTo: 'dashboard' }
    ],
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class PrivateViewsRoutes { }



// WEBPACK FOOTER //
// ./src/app/private-views/private-views.routes.ts